import PropTypes from "prop-types";
import React from "react";
import { Link } from 'gatsby';
import classnames from 'classnames';

import { data } from "../../globals/data/navigation";

import './styles.scss';

const MainNav = ({ className, ...restProps }) => (
  <nav className={classnames('ams-main-nav', className)} {...restProps}>
    <ul className="ams-main-nav__list">
      {data.map((item, i) => {
        return (
          <li className="ams-main-nav__item" key={i}>
            {renderNavItem(item)}
            {renderDropdown(item)}
          </li>
        );
      })}
    </ul>
  </nav>
);

function renderNavItem ({href, text, dropdown}) {
  if (!dropdown) {
    return <Link className="ams-main-nav__link" to={href}>{text}</Link>;
  }

  return (
    <button className="ams-main-nav__link">
      {text}
      <i class="ams-main-nav__link-icon fas fa-chevron-down"></i>
    </button>
  );
}

function renderDropdown ({href, text, dropdown}) {
  if (!dropdown) {
    return null;
  }

  return (
    <ul className="ams-main-nav-dropdown">
      {dropdown && dropdown.map(({href, text}) => {
        return (
          <li className="ams-main-nav-dropdown__item">
            <Link className="ams-main-nav-dropdown__link" to={href}>{text}</Link>
          </li>
        );
      })}
    </ul>
  );
}

export default MainNav;
